import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BinariesService } from 'src/app/services/binaries/binaries.service';
import { ConfigService } from 'src/app/services/config.service';
import { ApplianceGroup, DataRefsByKey } from '@shared/models/dataref.model';
import { PackLite } from '@shared/models/generic/pack-lite.model';
import { NotificationManagerService } from '@shared/services/notification-manager.service';
import { BinaryPackWithWarning } from '@shared/models/binaries/Binary-lite-with-warning.model';

@Component({
  selector: 'app-pack-generate-binary-form',
  templateUrl: './pack-generate-binary-form.component.html',
  styleUrls: ['./pack-generate-binary-form.component.scss'],
  standalone: false,
})
export class PackGenerateBinaryFormComponent {
  @Input() pack: PackLite = {} as PackLite;
  availableApplianceGroups: DataRefsByKey<ApplianceGroup> = {};
  @Output() displayBinariesPanel$: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() set applianceGroupsRefData(applianceGroupsRefData: DataRefsByKey<ApplianceGroup> | null) {
    if (applianceGroupsRefData) {
      // calculate appliance groupe for binaries in PACK
      this.eligibleApplianceGroups = this.binariesService.buildApplianceGroupsForBinariesPack(applianceGroupsRefData);
      if (this.eligibleApplianceGroups.length === 1) {
        this.formGroupGenerate.patchValue({
          applianceGroup: this.eligibleApplianceGroups[0].key,
        });
      }
      if (this.eligibleApplianceGroups.length < 1) {
        this.displayBinariesPanel$.emit(false);
      } else {
        this.displayBinariesPanel$.emit(true);
      }
    }
  }
  @Output() newBinaryHasBeenGenerated$: EventEmitter<void> = new EventEmitter<void>(true);

  eligibleApplianceGroups?: { key: string; label: string }[];
  generateFormErrorMessage = '';

  readonly types = [
    { key: 'USB', label: 'USB' },
    { key: 'CONNECT', label: 'Connect' },
  ];

  readonly formGroupGenerate: UntypedFormGroup = this.formBuilder.group({
    applianceGroup: new UntypedFormControl(undefined, Validators.required),
    type: new UntypedFormControl(this.types[0].key, Validators.required),
  });

  constructor(
    private readonly binariesService: BinariesService,
    private readonly configService: ConfigService,
    private readonly notificationManagerService: NotificationManagerService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  shouldDisableGeneration(): boolean {
    this.generateFormErrorMessage = '';

    if (!this.pack) {
      return true;
    }

    if (!this.eligibleApplianceGroups?.length || this.formGroupGenerate.invalid) {
      this.generateFormErrorMessage = 'BINARIES.MSG.ERROR.APPLIANCE_GROUPE_PACK';
      return true;
    }

    return false;
  }

  generate(): void {
    if (this.shouldDisableGeneration()) {
      return undefined;
    }
    this.binariesService
      .generateForPack({
        packId: this.pack.key,
        ...this.formGroupGenerate.value,
      })
      .subscribe(
        (res: BinaryPackWithWarning) => {
          this.notificationManagerService.displaySuccess('BINARIES.GENERATED');
          this.handleGenerationWarnings(res);
          this.newBinaryHasBeenGenerated$.emit();
        },
        (err) => {
          this.notificationManagerService.displayHttpError(err);
        },
      );
  }

  handleGenerationWarnings(res: BinaryPackWithWarning): void {
    if (!res?.errors?.length) {
      return;
    }
    this.notificationManagerService.displayError(this.notificationManagerService.generateErrors(res.errors).join('\n\n'));
  }
}
